import { Box } from '@/src/packages/components/ui/Box';
import { Button } from '@/src/packages/components/ui/Button';
import { useProductCardContext } from '@/src/packages/components/ui/ProductCard/ProductCardContext';
import { ProductCardInlineForm } from '@/src/packages/components/ui/ProductCard/ProductCardInlineForm';
import { ProductCardPrice } from '@/src/packages/components/ui/ProductCard/ProductCardPrice';
import { ProductCardTitle } from '@/src/packages/components/ui/ProductCard/ProductCardTitle';
import { cn } from '@/src/packages/utils/cn';
import { useDisclosure } from '@bitmap/utils/hooks/use-disclosure';

export const ProductCardFooter = () => {
  const { productVariant, isHovered } = useProductCardContext();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleOpenPreview = (e: React.MouseEvent) => {
    e.preventDefault();
    onOpen();
  };

  return (
    <>
      <Box as="footer" display="flex" className="flex-col relative group">
        <Box paddingTop={4} paddingBottom={8} paddingX={4}>
          <Box className="space-y-1">
            <ProductCardTitle />
            <ProductCardPrice />
          </Box>
        </Box>

        <Button
          className={cn('lg:opacity-0', {
            'opacity-100': isHovered,
          })}
          variant="solid"
          
          size="lg"
        >
          Shop item
        </Button>
      </Box>
      <ProductCardInlineForm
        isOpen={isOpen}
        productVariant={productVariant}
        handleClose={onClose}
      />
    </>
  );
};
